function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1)
  },
  group: {
    display: "flex",
    flexDirection: props => {
      return props.direction;
    }
  }
}));

const CheckboxesField = (_ref) => {
  let id = _ref.id,
      disabled = _ref.disabled,
      label = _ref.label,
      helperText = _ref.helperText,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      autofocus = _ref.autofocus,
      readonly = _ref.readonly,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "disabled", "label", "helperText", "options", "value", "autofocus", "readonly", "onChange"]);

  const classes = useStyles();

  const handleUnselect = (value, selected = []) => {
    return selected.filter(v => v !== value);
  };

  const handleSelect = (value, selected = [], all) => {
    const at = all.indexOf(value);
    const updated = selected.slice(0, at).concat(value, selected.slice(at));
    return updated.sort((a, b) => all.indexOf(a) > all.indexOf(b));
  };

  const handleChange = (event, option) => {
    let newValue = [];
    const all = options.map(({
      value
    }) => value);

    if (event.target.checked) {
      newValue = handleSelect(option.value, value, all);
    } else {
      newValue = handleUnselect(option.value, value);
    }

    onChange(newValue);
  };

  return React.createElement(FormControl, {
    className: classes.root,
    component: "fieldset"
  }, React.createElement(FormLabel, {
    component: "legend"
  }, label), React.createElement(FormGroup, null, options.map((option, index) => {
    return React.createElement(FormControlLabel, {
      control: React.createElement(Checkbox, {
        checked: value.includes(option.value),
        color: "primary",
        onChange: event => handleChange(event, option),
        value: option.value
      }),
      label: option.label || option.value
    });
  })), helperText && React.createElement(FormHelperText, null, helperText));
};

CheckboxesField.defaultProps = {
  autofocus: false,
  options: {
    inline: false
  }
};
CheckboxesField.propTypes = process.env.NODE_ENV !== "production" ? {} : {};
export default CheckboxesField;